import initialState from '../initialstate';
import * as types from '../../actions/actiontypes';

export default function RollForwardModeReducer(
	state = initialState.isRollForwardMode,
	action
) {
	switch (action.type) {
		case types.SET_ROLL_FORWAD_MODE: {
			return action.isRollForwardMode;
		}
		default:
			return state;
	}
}